<template>
  <nav
    class="top-0 fixed z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-dark-bgbbnav "
  >
  
    <div
      class="container px-4 mx-auto flex flex-wrap items-center justify-between"
    >
      <div
        class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start "
      >
        <router-link to="/">
          <a
            class="text-bgbb-y font-bold text-lg leading-relaxed inline-block mr-4 py-2 whitespace-no-wrap pr-22"
            href="#"
          >
            BGBB.IO
          </a>
        </router-link>

        <button
          class="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
          type="button"
          v-on:click="setNavbarOpen"
        >
          <i class="text-bgbb-y fas fa-bars"></i>
        </button>
      </div>
      <div
        class="lg:flex flex-grow items-center "
        :class="[navbarOpen ? 'block' : 'hidden']"
      
      >
        <!-- 
<ul class="flex flex-col lg:flex-row list-none mr-auto">
<li class="flex items-center">

 <a class="text-white px-3 py-2 flex items-center text-bases" href="https://github.com/BGBB-token/papers/raw/6325b50fcf238cf8c3d540cc42e58d26f09fecf6/White_Paper_V1.0.pdf" >
<i class="text-white text-lg leading-lg mr-2"/> White Paper</a>

</li></ul> -->

        <!-- <ul class="flex flex-col lg:flex-row list-none mr-auto">
          <li class="flex items-center">
            <a
              class="text-white px-3 py-2 flex items-center text-base"
              href="https://github.com/BGBB-token/papers/raw/6325b50fcf238cf8c3d540cc42e58d26f09fecf6/Technical_Paper_V1.0.pdf"
            >
              <i class="text-white text-lg leading-lg mr-2" />  Technical Paper
            </a>
          </li>
        </ul> -->

        <ul class="flex flex-col lg:flex-row list-none mr-auto">
          <li class="flex items-center">
            <a
              class="text-white px-3 py-2 flex items-center text-base"
              href="/overview"
            >
              <i class="text-white text-lg leading-lg mr-2" />Overview</a
            >
          </li>
        </ul>

        <ul class="flex flex-col lg:flex-row list-none mr-auto">
          <li class="flex items-center">
            <a
              class="text-white px-specialmenu py-2 flex items-center text-base"
              href="/#quickreservation"
            >
              <i class="text-white text-lg leading-lg mr-2" /> Reservation
            </a>
          </li>
        </ul>

        <ul class="flex flex-col lg:flex-row list-none mr-auto">
          <li class="flex items-center">
            <a
              class="text-white px-specialmenu py-2 flex items-center text-base"
              href="/staking"
            >
              <i class="text-white text-lg leading-lg mr-2" /> Staking
            </a>
            <!-- <span class="text-bgbb-y text-xs">[soon]</span> -->
          </li>
        </ul>

        <ul class="flex flex-col lg:flex-row list-none mr-auto">
          <li class="flex items-center">
            <a
              class="text-white px-specialmenu2 py-2 flex items-center text-base"
              href="/NFT-marketplace"
            >
              <i class="text-white text-lg leading-lg mr-2" /> NFT
              Marketplace</a
            >
            <!-- <span class="text-bgbb-y text-xs">[soon]</span> -->
          </li>
        </ul>

        <ul class="flex flex-col lg:flex-row list-none mr-auto">
          <li class="flex items-center">
            <a
              class="text-white px-specialmenu2 py-2 flex items-center text-base"
              href="/bounty-and-lottery"
            >
              <i class="text-white text-lg leading-lg mr-2" /> Bounty &
              Lottery</a
            >
            <!-- <span class="text-bgbb-y text-xs">[soon]</span> -->
          </li>
        </ul>

        <!-- 2 part header -->

        <ul class="flex flex-col lg:flex-row list-none lg:ml-auto">
          <li class="flex items-center">
            <a
              class="text-white px-2 py-2 flex items-center text-xs uppercase font-bold"
              href="https://discord.gg/7bVKAPYEkq"
              target="_blank"
            >
              <i class="text-white fab fa-discord text-lg leading-lg" />
              <span class="lg:hidden inline-block ml-2">Discord</span>
            </a>
          </li>

          <li class="flex items-center">
            <a
              class="text-white px-2 py-2 flex items-center text-xs uppercase font-bold"
              href="https://t.me/BGBB_Token"
              target="_blank"
            >
              <i class="text-white fab fa-telegram text-lg leading-lg" />
              <span class="lg:hidden inline-block ml-2">Telegram</span>
            </a>
          </li>

          <li class="flex items-center">
            <a
              class="text-white px-2 py-2 flex items-center text-xs uppercase font-bold"
              href="https://medium.com/@bgbb_token"
              target="_blank"
            >
              <i class="text-white fab fa-medium text-lg leading-lg" />
              <span class="lg:hidden inline-block ml-2">Medium</span>
            </a>
          </li>

          <li class="flex items-center">
            <a
              class="text-white px-2 py-2 flex items-center text-xs uppercase font-bold"
              href="https://twitter.com/BgbbToken"
              target="_blank"
            >
              <i class="text-white fab fa-twitter text-lg leading-lg" />
              <span class="lg:hidden inline-block ml-2">Tweet</span>
            </a>
          </li>

          <li class="flex items-center">
            <a
              class="text-white px-2 py-2 flex items-center text-xs uppercase font-bold"
              href="https://github.com/BGBB-token"
              target="_blank"
            >
              <i class="text-white fab fa-github text-lg leading-lg" />
              <span class="lg:hidden inline-block ml-2">GitHub</span>
            </a>
          </li>

          <li class="flex items-center">
            <button v-on:click="login"
              class="shadow-2xl bg-bgbb-y text-dark active:bg-green-600 text-xs font-bold px-4 py-2 rounded hover:shadow-lg outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150"
              type="button"
            >    
      
               <span class="fas fa-wallet mr-2"> </span>
              <span id="account">CONNECT WALLET</span>
            </button>
            
          </li>
        </ul>
        <button v-show="logOutvisible" id="loggout" class="ml-2 text-white" type="button" v-on:click="logout"> <i class="fas fa-sign-out-alt"></i></button>
        
       
       
      </div>



      
    </div>



  </nav>


</template>

<script>
// import IndexDropdown from "@/components/Dropdowns/IndexDropdown.vue";


import Web3 from 'web3';
const Moralis = require('moralis');
let data = new Moralis.Web3();
console.log('Moralis');
console.log(data);
Moralis.initialize("pjx5QzyCaQSkMthScEsv06x3jkxt0eW2TQwlsiAj", "nUrvbOC5ExJBgj8b6gOOMKAN2GERL1vGe1wHmCG4");
Moralis.serverURL = 'https://b6r7kfexiuct.moralis.io:2053/server';
let web3 = new Web3('ws://localhost:3000');
console.log('WEB 3');
console.log(web3);

const NODE_URL = "https://speedy-nodes-nyc.moralis.io/8e9707e6b8f5a3a0d708309e/bsc/testnet";
const provider = new Web3.providers.HttpProvider(NODE_URL);
const web33 = new Web3(provider);
console.log(web33);




export default {
  data() {
    return {
      navbarOpen: false,
      logOutvisible: true,

    };
  },
  methods: {
    setNavbarOpen: function () {
      this.navbarOpen = !this.navbarOpen;
    },
    async getUser(){
        console.log(web3);  
    },
    login(){
        Moralis.Web3.authenticate().then(function (user) {
        console.log('MORALIS SUCCESS');
        console.log(user.get('ethAddress'));  
        const template = document.getElementById('account');
        // template.innerHTML = userAddress;
        var string = user.get('ethAddress');
        var strshortened = string.slice(0,6);
        console.log(template.innerHTML);
        console.log('First 6');
        console.log(strshortened);
        console.log('Last 4');
        var lastFour = string.substr(string.length - 4);
        console.log(lastFour);
        var elipses = "...";
        var finalwallet = strshortened + elipses + lastFour;
        console.log(finalwallet);
        template.innerHTML = finalwallet;
             
        });

        this.logOutvisible = true;
     },
     
     
     async logout(){
         console.log('LOGOUT');
          await Moralis.User.logOut();
          const template = document.getElementById('account');
          template.innerHTML = "CONNECT WALLET";
          this.logOutvisible = false;
      }  
  },
  components: {
    // IndexDropdown,
  },
    mounted() {
          var template = document.getElementById('account');
          if(!Moralis.User.current()){
            this.logOutvisible = false;
          }else{
            this.logOutvisible = true;
            const user = Moralis.User.current();
            const string = user.get("ethAddress");
            console.log('ADDRESS');
            console.log(string);  
            var strshortened = string.slice(0,6);
            var lastFour = string.substr(string.length - 4);
            var elipses = "...";
            var finalwallet = strshortened + elipses + lastFour;
            template.innerHTML = finalwallet;      
      }
  },
};
</script>
